import type { LanguageType } from "./type";

// 从 localStorage 读取保存的语言设置，默认使用简体中文
export const getInitialLanguage = (): LanguageType => {
  const savedLanguage = localStorage.getItem("language") as LanguageType;
  if (
    savedLanguage &&
    (savedLanguage === "zh-CN" ||
      savedLanguage === "zh-HK" ||
      savedLanguage === "en-US")
  ) {
    return savedLanguage;
  }
  return "zh-CN";
};
